import { Stack } from '@mui/material';
import MyEvents from '../MyEvents/MyEvents';


export default function Home() {
    return (
        <Stack display='flex' height='100%' flexGrow={1} width='100%'>
            <MyEvents />
        </Stack>
    );
} 